import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'what_percentage_workers_are_paid_card_stored_value'

export const dataPointDefinition = {
  retracedId: 'what_percentage_workers_are_paid_card_stored_value',
  name: 'What percentage of workers are paid by card (with a stored value)?',
  description: 'Enter a decimal number. E.g., for 100% enter 1.0. For 75% enter 0.75.',
  meta: {
    slcpMeta: {
      key: 'wb-15-5f',
      number: 'WB-WAGE-103',
      dataType: 'numeric-percentage',
      masterType: 'Question',
      multiSelectKey: '',
      optionList: '',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],wb-15-5x',
      machineShowHide: '[2],wb-15-5x',
      completionCondition: 'any',
    },
    unit: 'PERCENTAGE',
    min: 0,
    max: 100,
  },
  fieldTypeId: 'NUMBER_UOM',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
        minimum: 0,
        maximum: 100,
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wb-15-5f', version: '1.7.0', provider: 'slcp'}],
  sortingId: 35010,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
